import { render } from "./AttachView.vue?vue&type=template&id=fc28626c&scoped=true"
import script from "./AttachView.vue?vue&type=script&lang=js"
export * from "./AttachView.vue?vue&type=script&lang=js"

import "./AttachView.vue?vue&type=style&index=0&id=fc28626c&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc28626c"]])

export default __exports__